


jQuery(function($) {
    $(function(){

        var breakpoint = $('#animatebreak').offset().top;
        var animate_node = $('.AnimateNode');
        var animate_img = $('.AnimateImg');
        animate_img.css({"position" : "relative"});

        var AnimateNode = function AnimateNode(){
            scrollTop = $(window).scrollTop();
            animate_node.each(function(){
                var node_from_top = $(this).offset().top;
                var node_distance = node_from_top - scrollTop;
                if(node_distance < breakpoint){
                    $(this).removeClass('AnimateNode--toptocenter');
                    $(this).removeClass('AnimateNode--righttocenter');
                    $(this).removeClass('AnimateNode--downtocenter');
                    $(this).removeClass('AnimateNode--lefttocenter');
                    $(this).removeClass('AnimateNode--scale0to1');
                    $(this).removeClass('AnimateNode--flipX');
                    $(this).removeClass('AnimateNode--flipY');

                    //custom
                    $(this).removeClass('AnimateNode--pretitle');
                }
            });
            animate_img.each(function(){
                var node_from_top = $(this).offset().top;
                var node_distance = node_from_top - scrollTop;
                if(node_distance < breakpoint){
                    $(this).addClass('AnimateImg--active');
                }
            });
        };

        AnimateNode();
        $(window).on('scroll', function(){
            AnimateNode();
        });
    });
});


//
// /* GSAP */
//
//
//
// /* GSAP */
//
// console.log('----GS-START----');
//
//
// // /****************** Banner Anims ******************/
// var banner_anims = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".banner",
//         start: "top bottom",
//         markers: false
//     }
// });
// banner_anims.addLabel("start")

//     banner_anims.from(CSSRulePlugin.getRule(".banner__pretitle:before"), .1, {
//         cssRule: {
//             opacity: 0,
//             width: 0 + '%',
//         },
//     }, 1)

//     // .to(".banner__pretitle span", {opacity: 1, duration: .3, delay: .1}, 1)

//     banner_anims.from(CSSRulePlugin.getRule(".banner__pretitle:after"), .1, {
//         cssRule: {
//             opacity: 0,
//             width: 0 + '%',
//         },
//     }, 1)
//
//     // Banner Home
//     // .from(".homesvgtext1", {opacity: 0, duration: .3, delay: 0}, 3)
//     // .from(".homesvgtext1", {rotate: 3 + 'deg', duration: .3, delay: 0}, 3)
//     // .from(".homesvgtext2", {opacity: 0, duration: .3, delay: 0}, 4)
//     // .from(".homesvgtext2", {rotate: 3 + 'deg', duration: .3, delay: 0}, 4)
//     // .from(".homesvgtext3", {opacity: 0, duration: .3, delay: 0}, 5)
//     // .from(".homesvgtext3", {rotate: 3 + 'deg', duration: .3, delay: 0}, 5)
//     // .from(".homesvgtext4", {opacity: 0, duration: .3, delay: 0}, 6)
//     // .from(".homesvgtext4", {rotate: 3 + 'deg', duration: .3, delay: 0}, 6)
//     // .from(".homesvgtext5", {opacity: 0, duration: .3, delay: 0}, 7)
//     // .from(".homesvgtext5", {rotate: 3 + 'deg', duration: .3, delay: 0}, 7)
//     // .to(".homesvglink", {opacity: 1, duration: .3, delay: 0}, 8)
//     // .from(".homesvglink", {y: 60, duration: .3, delay: 0}, 8)
//     .from(".homesvgtext1", {opacity: 0, duration: .3, delay: .3}, 3)
//     .from(".homesvgtext1", {rotate: 3 + 'deg', duration: .3, delay: .3}, 3)
//     .from(".homesvgtext2", {opacity: 0, duration: .3, delay: .3}, 3)
//     .from(".homesvgtext2", {rotate: 3 + 'deg', duration: .3, delay: .3}, 3)
//     .from(".homesvgtext3", {opacity: 0, duration: .3, delay: .3}, 3)
//     .from(".homesvgtext3", {rotate: 3 + 'deg', duration: .3, delay: .3}, 3)
//     .from(".homesvgtext4", {opacity: 0, duration: .3, delay: .3}, 3)
//     .from(".homesvgtext4", {rotate: 3 + 'deg', duration: .3, delay: .3}, 3)
//     .from(".homesvgtext5", {opacity: 0, duration: .3, delay: .3}, 3)
//     .from(".homesvgtext5", {rotate: 3 + 'deg', duration: .3, delay: .3}, 3)
//     .to(".homesvglink", {opacity: 1, duration: .3, delay: .3}, 3)
//     .from(".homesvglink", {y: 60, duration: .3, delay: .3}, 3)
//
//
//     // Banner Archive Works
//     // .from(".workssvgtext1", {opacity: 0, duration: .3, delay: 0}, 3)
//     // .from(".workssvgtext1", {rotate: 3 + 'deg', duration: .3, delay: 0}, 3)
//     // .from(".workssvgtext2", {opacity: 0, duration: .3, delay: 0}, 4)
//     // .from(".workssvgtext2", {rotate: 3 + 'deg', duration: .3, delay: 0}, 4)
//     // .from(".workssvgtext3", {opacity: 0, duration: .3, delay: 0}, 5)
//     // .from(".workssvgtext3", {rotate: 3 + 'deg', duration: .3, delay: 0}, 5)
//     // .to(".workssvglink", {opacity: 1, duration: .3, delay: 0}, 6)
//     // .from(".workssvglink", {y: 60, duration: .3, delay: 0}, 6)
//     .from(".workssvgtext1", {opacity: 0, duration: .3, delay: .3}, 3)
//     .from(".workssvgtext1", {rotate: 3 + 'deg', duration: .3, delay: .3}, 3)
//     .from(".workssvgtext2", {opacity: 0, duration: .3, delay: .3}, 3)
//     .from(".workssvgtext2", {rotate: 3 + 'deg', duration: .3, delay: .3}, 3)
//     .from(".workssvgtext3", {opacity: 0, duration: .3, delay: .3}, 3)
//     .from(".workssvgtext3", {rotate: 3 + 'deg', duration: .3, delay: .3}, 3)
//     .to(".workssvglink", {opacity: 1, duration: .3, delay: .3}, 3)
//     .from(".workssvglink", {y: 60, duration: .3, delay: .3}, 3)
//
//     // Banner Single Works
//     .to(".banner__title", {opacity: 1, duration: .3, delay: 0}, 3)
//     .from(".banner__title", {rotate: 3 + 'deg', duration: .3, delay: 0}, 3)
//     .to(".workssinglelink", {opacity: 1, duration: .3, delay: 0}, 4)
//     .from(".workssinglelink", {rotate: 3 + 'deg', duration: .3, delay: 0}, 4)
//
//     // Banner Mixed
//     .from(".banner__article", {opacity: 0, duration: .3, delay: 0}, 4)
//     .from(".banner__article", {rotate: 3 + 'deg', duration: .3, delay: 0}, 4)
//     .to(".bannermixlink", {opacity: 1, duration: .3, delay: 0}, 5)
//     .from(".bannermixlink", {y: 60, duration: .3, delay: 0}, 5)
//
//     banner_anims.to(CSSRulePlugin.getRule(".banner--workssingle .banner__image::before"), .1, {
//         cssRule: {
//             width: 0 + '%',
//         },
//     }, 5)
//     banner_anims.to(CSSRulePlugin.getRule(".banner--workssingle .banner__image::after"), .1, {
//         cssRule: {
//             width: 100 + '%',
//         },
//     }, 5)
//
//
//     // Banner Archive Posts
//     // .from(".postlistsvgtext1", {opacity: 0, duration: .3, delay: 0}, 3)
//     // .from(".postlistsvgtext1", {rotate: 3 + 'deg', duration: .3, delay: 0}, 3)
//     // .from(".postlistsvgtext2", {opacity: 0, duration: .3, delay: 0}, 4)
//     // .from(".postlistsvgtext2", {rotate: 3 + 'deg', duration: .3, delay: 0}, 4)
//     // .from(".postlistsvgtext3", {opacity: 0, duration: .3, delay: 0}, 5)
//     // .from(".postlistsvgtext3", {rotate: 3 + 'deg', duration: .3, delay: 0}, 5)
//     // .from(".postlistsvgtext4", {opacity: 0, duration: .3, delay: 0}, 6)
//     // .from(".postlistsvgtext4", {rotate: 3 + 'deg', duration: .3, delay: 0}, 6)
//     // .to(".bannerpostlink", {opacity: 1, duration: .3, delay: 0}, 7)
//     // .from(".bannerpostlink", {y: 60, duration: .3, delay: 0}, 7)
//     .from(".postlistsvgtext1", {opacity: 0, duration: .3, delay: .3}, 3)
//     .from(".postlistsvgtext1", {rotate: 3 + 'deg', duration: .3, delay: .3}, 3)
//     .from(".postlistsvgtext2", {opacity: 0, duration: .3, delay: .3}, 3)
//     .from(".postlistsvgtext2", {rotate: 3 + 'deg', duration: .3, delay: .3}, 3)
//     .from(".postlistsvgtext3", {opacity: 0, duration: .3, delay: .3}, 3)
//     .from(".postlistsvgtext3", {rotate: 3 + 'deg', duration: .3, delay: .3}, 3)
//     .from(".postlistsvgtext4", {opacity: 0, duration: .3, delay: .3}, 3)
//     .from(".postlistsvgtext4", {rotate: 3 + 'deg', duration: .3, delay: .3}, 3)
//     .to(".bannerpostlink", {opacity: 1, duration: .3, delay: .3}, 3)
//     .from(".bannerpostlink", {y: 60, duration: .3, delay: .3}, 3)
//
//
//     // Banner Contact Page
//     // .from(".contactsvgtext1", {opacity: 0, duration: .3, delay: 0}, 3)
//     // .from(".contactsvgtext1", {rotate: 3 + 'deg', duration: .3, delay: 0}, 3)
//     // .from(".contactsvgtext2", {opacity: 0, duration: .3, delay: 0}, 4)
//     // .from(".contactsvgtext2", {rotate: 3 + 'deg', duration: .3, delay: 0}, 4)
//     // .from(".contactsvgtext3", {opacity: 0, duration: .3, delay: 0}, 5)
//     // .from(".contactsvgtext3", {rotate: 3 + 'deg', duration: .3, delay: 0}, 5)
//     // .from(".contactsvgtext4", {opacity: 0, duration: .3, delay: 0}, 6)
//     // .from(".contactsvgtext4", {rotate: 3 + 'deg', duration: .3, delay: 0}, 6)
//     .from(".contactsvgtext1", {opacity: 0, duration: .3, delay: .3}, 3)
//     .from(".contactsvgtext1", {rotate: 3 + 'deg', duration: .3, delay: .3}, 3)
//     .from(".contactsvgtext2", {opacity: 0, duration: .3, delay: .3}, 3)
//     .from(".contactsvgtext2", {rotate: 3 + 'deg', duration: .3, delay: .3}, 3)
//     .from(".contactsvgtext3", {opacity: 0, duration: .3, delay: .3}, 3)
//     .from(".contactsvgtext3", {rotate: 3 + 'deg', duration: .3, delay: .3}, 3)
//     .from(".contactsvgtext4", {opacity: 0, duration: .3, delay: .3}, 3)
//     .from(".contactsvgtext4", {rotate: 3 + 'deg', duration: .3, delay: .3}, 3)
//     .to(".contactlink", {opacity: 1, duration: .3, delay: .3}, 3)
//     .from(".contactlink", {y: 60, duration: .3, delay: .3}, 3)
//
//
// .addLabel("end");
// // /****************** Banner Anims ******************/
//
//
//
// /****************** Home Intro Image Anims ******************/
// gsap.to(".homeintroimage__image", {
//       backgroundPosition: "50% 100%",
//       ease: "none",
//       scrollTrigger: {
//         trigger: ".homeintroimage__image",
//         start: "top 80%",
//         end: "bottom top",
//         scrub: true,
//         scrub: 1,
//         // scrub: .1,
//       }
// });
//
// var Intro_Image_Anims = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".homeintroimage",
//         start: "top 80%",
//         markers: false
//     }
// });
// Intro_Image_Anims.addLabel("Intro section start")
//
//     Intro_Image_Anims.to(CSSRulePlugin.getRule(".homeintroimage:after"), .3, {
//         cssRule: {
//             height: 0 + '%',
//         },
//     }, 1)
//
//     .from(".homeintroimage__floattitle", {opacity: 0, duration: .3, delay: 0}, 2)
//     .from(".homeintroimage__floattitle", {y: 60, duration: .3, delay: .0}, 2)
//
//     Intro_Image_Anims.to(CSSRulePlugin.getRule(".homeintroimage .borderline__tl:after"), .1, {
//         cssRule: {
//             width: 100 + '%',
//         },
//     }, 3)
//
//     Intro_Image_Anims.to(CSSRulePlugin.getRule(".homeintroimage .borderline__tr:after"), .1, {
//         cssRule: {
//             height: 100 + '%',
//         },
//     }, 3)
//
//     Intro_Image_Anims.to(CSSRulePlugin.getRule(".homeintroimage .borderline__br:after"), .1, {
//         cssRule: {
//             width: 100 + '%',
//         },
//     }, 3)
//
//     Intro_Image_Anims.to(CSSRulePlugin.getRule(".homeintroimage .borderline__bl:before"), .1, {
//         cssRule: {
//             height: 100 + '%',
//         },
//     }, 3)
//
// .addLabel("Intro section start");
// /****************** Home Intro Image Anims ******************/
//
//
//
// /****************** Home Intro Anims ******************/
// var Intro_Anims = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".homeintro",
//         start: "top 80%",
//         markers: false
//     }
// });
//
// Intro_Anims.addLabel("section start")
//
//     Intro_Anims.to(CSSRulePlugin.getRule(".homeintro__pretitle:after"), .1, {
//         cssRule: {
//             width: 100 + '%',
//         },
//     }, 1)
//
//     .from(".homeintro__pretitle span", {opacity: 0, duration: .3, delay: .1}, 1)
//
//     Intro_Anims.to(CSSRulePlugin.getRule(".homeintro__pretitle:after"), .1, {
//         cssRule: {
//             width: 0 + '%',
//             left: 'inherit',
//         },
//     }, 2)
//
//     .from(".homeintro__title h2", {opacity: 0, duration: .3, delay: 0}, 2)
//     .from(".homeintro__title h2", {y: 60, duration: .3, delay: .0}, 2)
//
//     .from(".homeintro__link", {opacity: 0, duration: .3, delay: 0}, 3)
//     .from(".homeintro__link", {y: 60, duration: .3, delay: .0}, 3)
//
// .addLabel("section start");
//
//
// var Stat_Item = gsap.utils.toArray('.statitem');
// Stat_Item.forEach(function(target_item){
//
//     var timeline = gsap.timeline({
//         scrollTrigger: {
//             trigger: target_item,
//             start: "top 80%",
//             //scrub: true,
//             markers: false
//         }
//     });
//
//     var item_figure_ov = target_item.querySelectorAll(".statitem__ov");
//     var item_figure = target_item.querySelectorAll(".statitem__figure span");
//     var item_text_ov = target_item.querySelectorAll(".statitem__ovtext");
//     var item_text = target_item.querySelectorAll(".statitem__title p");
//
//     timeline.to(item_figure_ov, {width: 0, duration: .3, delay: 0}, 1)
//     timeline.from(item_figure, {opacity: 0, duration: .3, delay: 0}, 1)
//     timeline.to(item_text_ov, {width: 100 + '%', duration: .3, delay: 0}, 2)
//     timeline.from(item_text, {opacity: 0, duration: .3, delay: .1}, 2)
//     timeline.to(item_text_ov, {left: 'auto', duration: 0, delay: 0}, 3)
//     timeline.to(item_text_ov, {right: 0, duration: 0, delay: 0}, 3)
//     timeline.to(item_text_ov, {width: 0, duration: .3, delay: 0}, 3)
//
// });
// /****************** Home Intro Anims ******************/
//
//
//
// /****************** Home Method ******************/
// var Intro_Method = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".homemethod",
//         start: "top 80%",
//         markers: false
//     }
// });
//
// Intro_Method.addLabel("section start")
//
//     Intro_Method.to(CSSRulePlugin.getRule(".homemethod:after"), .1, {
//         cssRule: {
//             width: 0 + '%',
//         },
//     }, 1)
//
//     .from(".homemethod__pretitle", {opacity: 0, duration: .3, delay: 0}, 2)
//     .from(".homemethod__pretitle", {x: -60, duration: .3, delay: .0}, 2)
//
//     .from(".homemethod__title h3", {opacity: 0, duration: .3, delay: 0}, 3)
//     .from(".homemethod__title h3", {y: 60, duration: .3, delay: .0}, 3)
//
// .addLabel("section start");
// /****************** Home Method ******************/
//
//
//
// /****************** Home Serv Image ******************/
// gsap.to(".homeservimage__image", {
//       backgroundPosition: "50% 100%",
//       ease: "none",
//       scrollTrigger: {
//         trigger: ".homeservimage__image",
//         start: "top 80%",
//         end: "bottom top",
//         scrub: true,
//         scrub: 1,
//         // scrub: .1,
//       }
// });
//
// var Serv_Image_Anims = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".homeservimage",
//         start: "top 80%",
//         markers: false
//     }
// });
// Serv_Image_Anims.addLabel("Intro section start")
//
//     Serv_Image_Anims.to(CSSRulePlugin.getRule(".homeservimage:after"), .5, {
//         cssRule: {
//             height: 0 + '%',
//         },
//     }, 1)
//
//     .from(".homeservimage__floattitle", {opacity: 0, duration: .3, delay: 0}, 2)
//     .from(".homeservimage__floattitle", {y: 60, duration: .3, delay: .0}, 2)
//
//     Serv_Image_Anims.to(CSSRulePlugin.getRule(".homeservimage .borderline__tl:after"), .1, {
//         cssRule: {
//             width: 100 + '%',
//         },
//     }, 3)
//
//     Serv_Image_Anims.to(CSSRulePlugin.getRule(".homeservimage .borderline__tr:after"), .1, {
//         cssRule: {
//             height: 100 + '%',
//         },
//     }, 3)
//
//     Serv_Image_Anims.to(CSSRulePlugin.getRule(".homeservimage .borderline__br:after"), .1, {
//         cssRule: {
//             width: 100 + '%',
//         },
//     }, 3)
//
//     Serv_Image_Anims.to(CSSRulePlugin.getRule(".homeservimage .borderline__bl:before"), .1, {
//         cssRule: {
//             height: 100 + '%',
//         },
//     }, 3)
//
// .addLabel("Intro section start");
// /****************** Home Serv Image ******************/
//
//
//
// /****************** Home Serv Section ******************/
// var Serv_Anims = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".homeservices",
//         start: "top 80%",
//         markers: false
//     }
// });
//
// Serv_Anims.addLabel("section start")
//
//     Serv_Anims.to(CSSRulePlugin.getRule(".homeservices__pretitle:after"), .1, {
//         cssRule: {
//             width: 100 + '%',
//         },
//     }, 1)
//
//     .from(".homeservices__pretitle span", {opacity: 0, duration: .3, delay: .1}, 1)
//
//     Serv_Anims.to(CSSRulePlugin.getRule(".homeservices__pretitle:after"), .1, {
//         cssRule: {
//             width: 0 + '%',
//             left: 'inherit',
//         },
//     }, 2)
//
//     .from(".homeservices__title h2", {opacity: 0, duration: .3, delay: 0}, 2)
//     .from(".homeservices__title h2", {y: 60, duration: .3, delay: .0}, 2)
//
//     .from(".homeservices__link", {opacity: 0, duration: .3, delay: 0}, 3)
//     .from(".homeservices__link", {y: 60, duration: .3, delay: .0}, 3)
//
// .addLabel("section start");
//
//
// var Serv_Item = gsap.utils.toArray('.homedescitem');
// Serv_Item.forEach(function(target_item){
//
//     var timeline = gsap.timeline({
//         scrollTrigger: {
//             trigger: target_item,
//             start: "top 80%",
//             //scrub: true,
//             markers: false
//         }
//     });
//
//     var item_figure = target_item.querySelectorAll(".homedescitem__fig");
//     var item_title_ov = target_item.querySelectorAll(".homedescitem__ov");
//     var item_title = target_item.querySelectorAll(".homedescitem__title h6");
//     var item_article = target_item.querySelectorAll(".homedescitem__article p");
//
//     timeline.from(item_figure, {opacity: 0, duration: .3, delay: 0}, 1)
//     timeline.from(item_figure, {x: -30, duration: .3, delay: 0}, 1)
//     timeline.to(item_title_ov, {width: 100 + '%', duration: .3, delay: 0}, 2)
//     timeline.from(item_title, {opacity: 0, duration: .3, delay: .1}, 2)
//     timeline.to(item_title_ov, {left: 'auto', duration: 0, delay: 0}, 3)
//     timeline.to(item_title_ov, {right: 0, duration: 0, delay: 0}, 3)
//     timeline.to(item_title_ov, {width: 0, duration: .3, delay: 0}, 3)
//     timeline.from(item_article, {opacity: 0, duration: .3, delay: 0}, 4)
//     timeline.from(item_article, {y: 30, duration: .3, delay: 0}, 4)
//
// });
// /****************** Home Serv Section ******************/
//
//
//
// /****************** Home Works Section ******************/
// var Works_Anims = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".homeworks",
//         start: "top 80%",
//         markers: false
//     }
// });
//
// Works_Anims.addLabel("section start")
//
//     Works_Anims.to(CSSRulePlugin.getRule(".homeworks__pretitle:after"), .1, {
//         cssRule: {
//             width: 100 + '%',
//         },
//     }, 1)
//
//     .from(".homeworks__pretitle span", {opacity: 0, duration: .3, delay: .1}, 1)
//
//     Works_Anims.to(CSSRulePlugin.getRule(".homeworks__pretitle:after"), .1, {
//         cssRule: {
//             width: 0 + '%',
//             left: 'inherit',
//         },
//     }, 2)
//
//     .from(".homeworks__title h2", {opacity: 0, duration: .3, delay: 0}, 2)
//     .from(".homeworks__title h2", {y: 60, duration: .3, delay: .0}, 2)
//
//     .from(".homeworks__link", {opacity: 0, duration: .3, delay: 0}, 3)
//     .from(".homeworks__link", {y: 60, duration: .3, delay: .0}, 3)
//
// .addLabel("section start");
//
//
// var Works_item = gsap.utils.toArray('.postworks');
// Works_item.forEach(function(target_item){
//
//     var timeline = gsap.timeline({
//         scrollTrigger: {
//             trigger: target_item,
//             start: "top 80%",
//             //scrub: true,
//             markers: false
//         }
//     });
//
//     var item_figure = target_item.querySelectorAll(".postworks__figure");
//     var item_img_ov = target_item.querySelectorAll(".postworks__imgov");
//     var item_hov = target_item.querySelectorAll(".postworks__imghov");
//     var item_title = target_item.querySelectorAll(".postworks__title");
//     var item_article = target_item.querySelectorAll(".postworks__type");
//     var item_copy = target_item.querySelectorAll(".postworks__copy");
//
//     // timeline.from(item_figure, {opacity: 0, duration: .3, delay: 0}, 1)
//     // timeline.from(item_figure, {y: -60, duration: .3, delay: .0}, 1)
//     // timeline.to(item_img_ov, {width: 0, duration: .3, delay: 0}, 2)
//     //
//     // timeline.to(item_hov, {opacity: 1, duration: 0, delay: 0}, 3)
//     //
//     // timeline.from(item_title, {opacity: 0, duration: .3, delay: 0}, 3)
//     // timeline.from(item_title, {x: -60, duration: .3, delay: .0}, 3)
//     // timeline.from(item_article, {opacity: 0, duration: .3, delay: .2}, 3)
//     // timeline.from(item_article, {x: -60, duration: .3, delay: .2}, 3)
//     // timeline.from(item_copy, {opacity: 0, duration: .3, delay: .2}, 3)
//     // timeline.from(item_copy, {x: -60, duration: .3, delay: .2}, 3)
//
//     timeline.from(item_figure, {opacity: 0, duration: .3, delay: 0}, 1)
//     timeline.from(item_figure, {y: -60, duration: .3, delay: .0}, 1)
//     timeline.to(item_img_ov, {width: 0, duration: .3, delay: .2}, 1)
//     timeline.to(item_hov, {opacity: 1, duration: 0, delay: .2}, 1)
//     timeline.from(item_title, {opacity: 0, duration: .3, delay: .3}, 1)
//     timeline.from(item_title, {x: -60, duration: .3, delay: .3}, 1)
//     timeline.from(item_article, {opacity: 0, duration: .3, delay: .5}, 1)
//     timeline.from(item_article, {x: -60, duration: .3, delay: .5}, 1)
//     timeline.from(item_copy, {opacity: 0, duration: .3, delay: .6}, 1)
//     timeline.from(item_copy, {x: -60, duration: .3, delay: .6}, 1)
//
// });
//
// /****************** Home Works Section ******************/
//
//
// /****************** Post List Item ******************/
// var Post_List_item = gsap.utils.toArray('.postitem');
// Post_List_item.forEach(function(target_item){
//
//     var timeline = gsap.timeline({
//         scrollTrigger: {
//             trigger: target_item,
//             start: "top bottom",
//             //scrub: true,
//             markers: false
//         }
//     });
//
//     var item_ov = target_item.querySelectorAll(".postitem__ov");
//     var item_tag = target_item.querySelectorAll(".postitem__type");
//     var item_title = target_item.querySelectorAll(".postitem__title");
//
//     timeline.to(item_ov, {width: 0, duration: .3, delay: 0}, 1)
//     timeline.from(item_tag, {opacity: 0, duration: .3, delay: .2}, 2)
//     timeline.from(item_tag, {y: -30, duration: .3, delay: .2}, 2)
//     timeline.from(item_title, {opacity: 0, duration: .3, delay: .1}, 2)
//     timeline.from(item_title, {y: -30, duration: .3, delay: .1}, 2)
//
// });
// /****************** Post List Item ******************/
//
//
//
// /****************** Home Posts Section ******************/
// var Posts_Anims = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".homeposts",
//         start: "top 80%",
//         markers: false
//     }
// });
//
// Posts_Anims.addLabel("section start")
//
//     Posts_Anims.to(CSSRulePlugin.getRule(".homeposts__pretitle:after"), .1, {
//         cssRule: {
//             width: 100 + '%',
//         },
//     }, 1)
//
//     .from(".homeposts__pretitle span", {opacity: 0, duration: .3, delay: .1}, 1)
//
//     Posts_Anims.to(CSSRulePlugin.getRule(".homeposts__pretitle:after"), .1, {
//         cssRule: {
//             width: 0 + '%',
//             left: 'inherit',
//         },
//     }, 2)
//
//     .from(".homeposts__title h2", {opacity: 0, duration: .3, delay: 0}, 2)
//     .from(".homeposts__title h2", {y: 60, duration: .3, delay: .0}, 2)
//
//     .from(".homeposts__link", {opacity: 0, duration: .3, delay: 0}, 3)
//     .from(".homeposts__link", {y: 60, duration: .3, delay: .0}, 3)
//
// .addLabel("section start");
//
//
// var Post_Anims = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".homeposts__sliderwrap",
//         start: "top 80%",
//         markers: false
//     }
// });
//
// Post_Anims.addLabel("section start")
//
//     Post_Anims.to(CSSRulePlugin.getRule(".homeposts__sliderwrap:after"), .5, {
//         cssRule: {
//             height: 0 + '%',
//         },
//     }, 1)
//
// .addLabel("section start");
// /****************** Home Posts Section ******************/
//
//
//
// /****************** Contact Page ******************/
// var Contact_Anims = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".contactpage",
//         start: "top 80%",
//         markers: false
//     }
// });
// Contact_Anims.addLabel("section start")
//
//
//     .from(".contactpage__form", {opacity: 0, duration: .3, delay: 0}, 1)
//     .from(".contactpage__form", {y: 60, duration: .3, delay: .0}, 1)
//
//     .from(".contactpage__article", {opacity: 0, duration: .3, delay: 0}, 1)
//     .from(".contactpage__article", {x: 60, duration: .3, delay: .0}, 1)
//
//     .from(".contactpage__companyinfo", {opacity: 0, duration: .3, delay: 0}, 1)
//     .from(".contactpage__companyinfo", {x: 60, duration: .3, delay: .0}, 1)
//
//     .from(".contactpage__social", {opacity: 0, duration: .3, delay: 0}, 1)
//     .from(".contactpage__social", {x: 60, duration: .3, delay: .0}, 1)
//
//
// .addLabel("section start");
// /****************** Contact Page ******************/
//
//
// /*********************************** Flex Content ***********************************/
//
//
// /****************** Side Links ******************/
// var cta_side_link_title = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".sidelinklist",
//         start: "top bottom",
//         markers: false
//     }
// });
//
// cta_side_link_title.addLabel("section start")
//
//     .from(".sidelinklist__title", {opacity: 0, duration: .3, delay: 0}, 1)
//     .from(".sidelinklist__title", {x: -30, duration: .3, delay: .0}, 1)
//     .from(".sidelinklist__list", {opacity: 0, duration: .3, delay: 0}, 1)
//     .from(".sidelinklist__list", {x: -30, duration: .3, delay: .0}, 1)
//
// .addLabel("section start");
// /****************** Side Links ******************/
//
//
// /****************** Side Quote ******************/
// var cta_side_quote = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".sidequote",
//         start: "top bottom",
//         markers: false
//     }
// });
//
// cta_side_quote.addLabel("section start")
//
//     .from(".sidequote", {opacity: 0, duration: .3, delay: 0}, 1)
//     .from(".sidequote", {x: -30, duration: .3, delay: .0}, 1)
//
// .addLabel("section start");
// /****************** Side Quote ******************/
//
//
// /****************** Side CTA ******************/
// var cta_side = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".sidecta",
//         start: "top bottom",
//         markers: false
//     }
// });
//
// cta_side.addLabel("section start")
//
//     .from(".sidecta", {opacity: 0, duration: .3, delay: 0}, 1)
//     .from(".sidecta", {x: -30, duration: .3, delay: .0}, 1)
//
// .addLabel("section start");
// /****************** Side CTA ******************/
//
//
// /****************** Flex Editor ******************/
// var flex_editor = gsap.utils.toArray('.editorblock');
// flex_editor.forEach(function(target_item){
//
//     var timeline = gsap.timeline({
//         scrollTrigger: {
//             trigger: target_item,
//             start: "top bottom",
//             markers: false
//         }
//     });
//
//     var flex_editor_block = target_item.querySelectorAll(".editorblock__col");
//     timeline.from(flex_editor_block, {opacity: 0, duration: .3, delay: 0}, 1)
//     timeline.from(flex_editor_block, {y: 60, duration: .3, delay: .0}, 1)
//
// });
// /****************** Flex Editor ******************/
//
//
// /****************** Flex Row ******************/
// var flex_row = gsap.utils.toArray('.rowitem');
// flex_row.forEach(function(target_item){
//
//     var timeline = gsap.timeline({
//         scrollTrigger: {
//             trigger: target_item,
//             start: "top bottom",
//             markers: false
//         }
//     });
//
//     var flex_row_block_imgov = target_item.querySelectorAll(".rowitem__imgov");
//     var flex_row_block_content = target_item.querySelectorAll(".rowitem__content");
//
//     timeline.to(flex_row_block_imgov, {height: 0, duration: .3, delay: 0}, 1)
//     timeline.from(flex_row_block_content, {opacity: 0, duration: .3, delay: 0}, 1)
//     timeline.from(flex_row_block_content, {x: 60, duration: .3, delay: .0}, 1)
//
// });
// /****************** Flex Row ******************/
//
//
// /****************** Flex Col ******************/
// var flex_col = gsap.utils.toArray('.columnitem ');
// flex_col.forEach(function(target_item){
//
//     var timeline = gsap.timeline({
//         scrollTrigger: {
//             trigger: target_item,
//             start: "top bottom",
//             markers: false
//         }
//     });
//
//     var flex_col_imgov = target_item.querySelectorAll(".columnitem__imgov");
//     var flex_col_content = target_item.querySelectorAll(".columnitem__content");
//
//     timeline.to(flex_col_imgov, {height: 0, duration: .3, delay: 0}, 1)
//     timeline.from(flex_col_content, {opacity: 0, duration: .3, delay: 0}, 1)
//     timeline.from(flex_col_content, {y: 60, duration: .3, delay: .0}, 1)
//
// });
// /****************** Flex Col ******************/
//
//
// /****************** Flex Video ******************/
// var flex_video = gsap.utils.toArray('.videoblock');
// flex_video.forEach(function(target_item){
//
//     var timeline = gsap.timeline({
//         scrollTrigger: {
//             trigger: target_item,
//             start: "top bottom",
//             markers: false
//         }
//     });
//
//     var flex_video_item = target_item.querySelectorAll(".videoblock__video");
//     var flex_video_content = target_item.querySelectorAll(".videoblock__editor");
//
//     timeline.from(flex_video_item, {opacity: 0, duration: .3, delay: 0}, 1)
//     timeline.from(flex_video_item, {y: 60, duration: .3, delay: .0}, 1)
//     timeline.from(flex_video_content, {opacity: 0, duration: .3, delay: 0}, 2)
//     timeline.from(flex_video_content, {y: 60, duration: .3, delay: .0}, 2)
//
// });
// /****************** Flex Video ******************/
//
//
// /****************** Flex Accordion ******************/
// var flex_dropdown = gsap.utils.toArray('.accordionblock');
// flex_dropdown.forEach(function(target_item){
//
//     var timeline = gsap.timeline({
//         scrollTrigger: {
//             trigger: target_item,
//             start: "top bottom",
//             markers: false
//         }
//     });
//
//     var flex_dropdown_header = target_item.querySelectorAll(".accordionblock__head");
//
//     timeline.from(flex_dropdown_header, {opacity: 0, duration: .3, delay: 0}, 1)
//     timeline.from(flex_dropdown_header, {y: 60, duration: .3, delay: .0}, 1)
//
// });
// /****************** Flex Accordion ******************/
//
//
// /****************** Flex ImageSlide ******************/
// var flex_image_slider = gsap.utils.toArray('.imageslider');
// flex_image_slider.forEach(function(target_item){
//
//     var timeline = gsap.timeline({
//         scrollTrigger: {
//             trigger: target_item,
//             start: "top bottom",
//             markers: false
//         }
//     });
//
//     var flex_imageslide = target_item.querySelectorAll(".imageslider__items");
//     var flex_imageslide_nav = target_item.querySelectorAll(".imageslider__button");
//
//     timeline.from(flex_imageslide, {opacity: 0, duration: .3, delay: 0}, 1)
//     timeline.from(flex_imageslide, {y: 60, duration: .3, delay: .0}, 1)
//     timeline.from(flex_imageslide_nav, {opacity: 0, duration: .3, delay: 0}, 1)
//     timeline.from(flex_imageslide_nav, {y: 60, duration: .3, delay: .0}, 1)
//
// });
// /****************** Flex ImageSlide ******************/
//
//
// /****************** Flex Link Block ******************/
// var flex_link_block = gsap.utils.toArray('.linkblock');
// flex_link_block.forEach(function(target_item){
//
//     var timeline = gsap.timeline({
//         scrollTrigger: {
//             trigger: target_item,
//             start: "top bottom",
//             markers: false
//         }
//     });
//
//     var flex_link_ov = target_item.querySelectorAll(".linkblock__ov");
//     var flex_link_title = target_item.querySelectorAll(".linkblock__title");
//
//     timeline.to(flex_link_ov, {height: 0, duration: .3, delay: 0}, 1)
//     timeline.from(flex_link_title, {opacity: 0, duration: .3, delay: 0}, 2)
//     timeline.from(flex_link_title, {y: 60, duration: .3, delay: .0}, 2)
//
// });
// /****************** Flex Link Block ******************/
//
//
// /****************** Flex Mixed Block ******************/
// var flex_mixed_block = gsap.utils.toArray('.mixedblock');
// flex_mixed_block.forEach(function(target_item){
//
//     var timeline = gsap.timeline({
//         scrollTrigger: {
//             trigger: target_item,
//             start: "top bottom",
//             markers: false
//         }
//     });
//
//     var flex_mixed_imgov = target_item.querySelectorAll(".mixedblock__imgov");
//     var flex_mixed_content = target_item.querySelectorAll(".mixedblock__content");
//
//     timeline.to(flex_mixed_imgov, {height: 0, duration: .3, delay: 0}, 1)
//     timeline.from(flex_mixed_content, {opacity: 0, duration: .3, delay: 0}, 2)
//     timeline.from(flex_mixed_content, {y: 60, duration: .3, delay: .0}, 2)
//
// });
// /****************** Flex Mixed Block ******************/
//
//
//
// /****************** Flex Quote ******************/
// var flex_quote = gsap.utils.toArray('.quotetrigger');
// flex_quote.forEach(function(target_item){
//
//     var timeline = gsap.timeline({
//         scrollTrigger: {
//             trigger: target_item,
//             start: "top bottom",
//             markers: false
//         }
//     });
//
//     var flex_quote_block = target_item.querySelectorAll(".quoteblock");
//     var flex_quote_title = target_item.querySelectorAll(".quoteblock__title");
//     var flex_quote_by = target_item.querySelectorAll(".quoteblock__by");
//
//     timeline.from(flex_quote_block, {opacity: 0, duration: .3, delay: 0}, 1)
//     timeline.from(flex_quote_block, {y: 60, duration: .3, delay: .0}, 1)
//     timeline.from(flex_quote_title, {opacity: 0, duration: .3, delay: 0}, 2)
//     timeline.from(flex_quote_title, {y: 60, duration: .3, delay: .0}, 2)
//     timeline.from(flex_quote_by, {opacity: 0, duration: .3, delay: .1}, 2)
//     timeline.from(flex_quote_by, {y: 60, duration: .3, delay: .1}, 2)
//
// });
// /****************** Flex Quote ******************/
//
//
// /****************** Flex Modal ******************/
// var flex_modal = gsap.utils.toArray('.modalblock');
// flex_modal.forEach(function(target_item){
//
//     var timeline = gsap.timeline({
//         scrollTrigger: {
//             trigger: target_item,
//             start: "top bottom",
//             markers: false
//         }
//     });
//
//     var flex_modal_cont = target_item.querySelectorAll(".modalblock__content");
//
//     timeline.from(flex_modal_cont, {opacity: 0, duration: .3, delay: 0}, 1)
//     timeline.from(flex_modal_cont, {y: 60, duration: .3, delay: .0}, 1)
//
// });
// /****************** Flex Modal ******************/
//
//
// /****************** Flex Tabs ******************/
// var flex_tabs = gsap.utils.toArray('.tabsblock');
// flex_tabs.forEach(function(target_item){
//
//     var timeline = gsap.timeline({
//         scrollTrigger: {
//             trigger: target_item,
//             start: "top bottom",
//             markers: false
//         }
//     });
//
//     var flex_tabs_header = target_item.querySelectorAll(".tabsblock__tabs");
//     var flex_tabs_content = target_item.querySelectorAll(".tabsblock__content");
//
//     timeline.from(flex_tabs_header, {opacity: 0, duration: .3, delay: 0}, 1)
//     timeline.from(flex_tabs_header, {y: 60, duration: .3, delay: .0}, 1)
//     timeline.from(flex_tabs_content, {opacity: 0, duration: .3, delay: 0}, 2)
//     timeline.from(flex_tabs_content, {y: 60, duration: .3, delay: .0}, 2)
//
// });
// /****************** Flex Tabs ******************/
//
//
// /****************** Flex Form ******************/
// var flex_form = gsap.utils.toArray('.formblock');
// flex_form.forEach(function(target_item){
//
//     var timeline = gsap.timeline({
//         scrollTrigger: {
//             trigger: target_item,
//             start: "top bottom",
//             markers: false
//         }
//     });
//
//     var flex_form_content = target_item.querySelectorAll(".formblock__content");
//     var flex_tabs_form = target_item.querySelectorAll(".formblock__form");
//
//     timeline.from(flex_form_content, {opacity: 0, duration: .3, delay: 0}, 1)
//     timeline.from(flex_form_content, {y: 60, duration: .3, delay: .0}, 1)
//     timeline.from(flex_tabs_form, {opacity: 0, duration: .3, delay: 0}, 2)
//     timeline.from(flex_tabs_form, {y: 60, duration: .3, delay: .0}, 2)
//
// });
// /****************** Flex Form ******************/
//
//
//
// /****************** Flex Skills ******************/
// var flex_skills = gsap.utils.toArray('.techitem');
// flex_skills.forEach(function(target_item){
//
//     var timeline = gsap.timeline({
//         scrollTrigger: {
//             trigger: target_item,
//             start: "top bottom",
//             markers: false
//         }
//     });
//
//     var flex_skills_icon = target_item.querySelectorAll(".techitem__icon");
//     var flex_skills_title = target_item.querySelectorAll(".techitem__title");
//
//     // timeline.from(flex_skills_icon, {scale: "-=1", duration: .3, delay: 0}, 1)
//     // timeline.from(flex_skills_icon, {scale: "+=1", duration: .3, delay: 0}, 1)
//     timeline.from(flex_skills_icon, {opacity: 0, duration: .3, delay: 0}, 1)
//     timeline.from(flex_skills_icon, {x: 30, duration: .3, delay: 0}, 1)
//     timeline.from(flex_skills_title, {opacity: 0, duration: .3, delay: .2}, 1)
//     timeline.from(flex_skills_title, {x: 30, duration: .3, delay: .2}, 1)
//
// });
//
// /****************** Flex Skills ******************/
//
//
// /*********************************** Flex Content ***********************************/
//
//
//
// /****************** Works Desc******************/
// var works_desc = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".worksingle__desc",
//         start: "top bottom",
//         markers: false
//     }
// });
//
// works_desc.addLabel("section start")
//
//     .from(".worksingle__desc", {opacity: 0, duration: .3, delay: 0}, 1)
//     .from(".worksingle__desc", {x: 30, duration: .3, delay: .0}, 1)
//
//     .from(".worksingle__link", {opacity: 0, duration: .3, delay: 0}, 2)
//     .from(".worksingle__link", {x: 30, duration: .3, delay: .0}, 2)
//
// .addLabel("section start");
// /****************** Works Desc******************/
//
//
// console.log('----GS-END---');
//
// /****************** Scrolling Text ******************/
// // gsap.set('.homeservicesfloat',{xPercent:0,yPercent:0})
// //
// //     var boxWidth = 620,
// //     totalWidth = boxWidth * 7,  //  * n of boxes
// //     no03 = document.querySelectorAll("#no03 .homeservtag"),
// //     dirFromLeft = "+=" + totalWidth,
// //     dirFromRight = "-=" + totalWidth;
// //
// //     var mod = gsap.utils.wrap(0, totalWidth);
// //
// // function marquee(which, time, direction){
// //     gsap.set(which, {
// //         x:function(i) {
// //             return i * boxWidth;
// //         }
// //     });
// //     var action = gsap.timeline()
// //     .to(which,  {
// //         x: direction,
// //         modifiers: {
// //         x: x => mod(parseFloat(x)) + "px"
// //         },
// //         duration:time, ease:'none',
// //         repeat:-1,
// //     });
// //     return action
// // }
// //
// // var master = gsap.timeline()
// // .add(marquee(no03, 30, dirFromRight), 3)
// /****************** Scrolling Text ******************/
// /* GSAP */
